import React, { useContext } from 'react';
import { Question, Topic, Answer, MultipleChoiceWrapper } from '../../../../services/types/Toolkit';
import QuestionComp from './Question';
import OperationContext from '../context';
import MainContext from '../../../App/MainProvider/context';
import Role from '../../../../types/role';

interface Props {
  topic: Topic;
  answers: Answer[];
  handleChange: (
    value: number,
    questionId: number,
    multipleChoice: MultipleChoiceWrapper | null
  ) => void;
  isDraft: boolean;
  isEspf: boolean;
}

const QuestionsTable = (props: Props) => {
  const { topic, answers, handleChange, isDraft, isEspf } = props;
  const { questions } = topic;
  const { operation } = useContext(OperationContext);
  const { user, inSuperUserMode } = useContext(MainContext);

  const renderQuestions = (rQuestions: Question[]) => {
    let q = rQuestions;
    if (answers.some((x) => x.questionId === 72 && x.value === 1)) {
      q = rQuestions.filter((x) => x.id === 72 || !isDraft);
    } else if (answers.some((x) => x.questionId === 85 && x.value === 0)) {
      q = rQuestions.filter((x) => x.id === 85 || !isDraft);
    } else if (answers.some((x) => x.questionId === 67 && x.value === 0)) {
      q = rQuestions.filter((x) => x.id === 67 || !isDraft);
    }

    return q.map((question: Question) => (
      <QuestionComp
        answers={answers}
        key={question.id.toString()}
        questionObj={question}
        handleChange={handleChange}
        disabled={
          !isDraft ||
          (!operation.isMember &&
            !inSuperUserMode() &&
            !(isEspf && user.roleCode === Role.HSO) &&
            !(isEspf && operation.belongsGS && user.isGuidanceService) &&
            !operation.userTaskDelegations.includes('TOOLKIT'))
        }
      />
    ));
  };

  return (
    <div className="table-responsive">
      <table className="question-table">
        <tbody>{questions && renderQuestions(questions)}</tbody>
      </table>
    </div>
  );
};

export default QuestionsTable;
